import { render, staticRenderFns } from "./QuestionPanel.vue?vue&type=template&id=52d2df2e"
import script from "./QuestionPanel.vue?vue&type=script&lang=ts"
export * from "./QuestionPanel.vue?vue&type=script&lang=ts"
import style0 from "./QuestionPanel.vue?vue&type=style&index=0&id=52d2df2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports